// extracted by mini-css-extract-plugin
export default {"root":"RefereeFormSubmission_root__2y0JN"};